import organizationSlice from './slice';

export const {
    addClientToOrganizationError,
    addClientToOrganization,
    addClientToOrganizationSuccess,

    getOrganizationClients,
    getOrganizationClientsError,
    getOrganizationClientsSuccess,

    getOrganisationInvitations,
    getOrganisationInvitationsError,
    getOrganisationInvitationsSuccess,

    addClientToOrganizationViaEmailError,
    addClientToOrganizationViaEmail,
    addClientToOrganizationViaEmailSuccess,


    addClientOrganization,
    addClientOrganizationError,
    addClientOrganizationSuccess,

    giveAccessToOrganization,
    giveAccessToOrganizationError,
    giveAccessToOrganizationSuccess,

    removeAccessToOrganization,
    removeAccessToOrganizationError,
    removeAccessToOrganizationSuccess,
    _UpdateremoveAccessToOrganizationSagaSucess,
    UpdateremoveAccessToOrganizationSaga,
    
    updateUsersPermissions,
    updateUsersPermissionsError ,
    updateUsersPermissionsSuccess,

    getOrganizationUsers,
    getOrganizationUsersError ,
    getOrganizationUsersSuccess,

    acceptOrganisationInvitation,
    acceptOrganisationInvitationError,
    acceptOrganisationInvitationSuccess,

    declineOrganisationInvitation,
    declineOrganisationInvitationError,
    declineOrganisationInvitationSuccess,

    deleteClientFromOrganisation,
    deleteClientFromOrganisationError,
    deleteClientFromOrganisationSuccess,

    addUser,
    addUserError ,
    addUserSuccess,

    removeUser,
    removeUserError ,
    removeUserSuccess,

    getOrganizationSites,
    getOrganizationSitesError,
    getOrganizationSitesSuccess,

    createClientOrganization,
    createClientOrganizationError,
    createClientOrganizationSuccess,

    getClientOrganizations,
    getClientOrganizationsError,
    getClientOrganizationsSuccess,
    resetOrganisationState,
    // get the current user organization.
    currentUserOrganizationAuthError,
    currentUserOrganizationAuth,
    currentUserOrganizationAuthSuccess,
  

    fetchClientSiteList,
    fetchClientSiteListError,
    fetchClientSiteListSuccess,

    deleteOrganizationfunError,
    deleteOrganizationfunSuccess,
    deleteOrganizationfun,
    
    fetchCompaniesError,
    fetchCompaniesSuccess,
    fetchCompanies,
    
    createCompany,
    createCompanyError,
    createCompanySuccess,
    
    inviteCompanyToOrganization,
    inviteCompanyToOrganizationError,
    inviteCompanyToOrganizationSuccess,

    getCompanyInvitationsToJoinOrganizationsError,
    getCompanyInvitationsToJoinOrganizations,
    getCompanyInvitationsToJoinOrganizationsSuccess,

    companyDeclinesInvetationError,
    companyDeclinesInvetation,
    companyDeclinesInvetationSuccess,

    companyAcceptInvetationError,
    companyAcceptInvetation,
    companyAcceptInvetationSuccess,

    getCompanyWebsiesError,
    getCompanyWebsies,
    getCompanyWebsiesSuccess,
    
    grantAccessToOrganizationError,
    grantAccessToOrganization,
    grantAccessToOrganizationSuccess,
    updategrantAccessToOrganizationSuccess,


    getJoinedOrganizationeError,
    getJoinedOrganization,
    getJoinedOrganizationSuccess,


    updateCompanyNameError,
    updateCompanyName,
    updateCompanyNameSuccess,
    updateCompanyNameMessage,

    getInfoIndustryError,
    getInfosIndustry,
    getInfoIndustrySuccess,

    updateInfoIndustryError,
    updateInfosIndustry,
    updateInfoIndustrySuccess,

    getOwnCompaniesError,
    getOwnCompanies,
    getOwnCompaniesSuccess,

    addCategory,
    addCategoryError,
    addCategorySuccess,

    updateCategory,
    updateCategoryError,
    updateCategorySuccess,

    deleteCategory,
    deleteCategoryError,
    deleteCategorySuccess,

    getOwnCompanyUsers,
    getOwnCompanyUsersSuccess,
    getOwnCompanyUsersError,

    removeUserFromCompany,
    removeUserFromCompanySuccess,
    removeUserFromCompanyError,

    assignComanyRole,
    assignComanyRoleSuccess,
    assignComanyRoleError,

    assignComanyPermission,
    assignComanyPermissionSuccess,
    assignComanyPermissionError,

    assignWebSitePermission,
    assignWebSitePermissionSuccess,
    assignWebSitePermissionError,

    resetState
} = organizationSlice.actions; 
export default organizationSlice.reducer;

export * from './types';